/**
 * 学习乐园 · 连连看题材包：省份连省会（lianliankan/pack-shenghui.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：省份连省会（「河北」连「石家庄」）。32 对 = 4 直辖市 + 23 省
 * + 5 自治区；港澳不收——特别行政区没有「省会」概念，硬编是教错。
 * 34 格棋盘一局抽 18 对，34 省一周玩不完一遍，每局组合都不同。
 * note 是该省简称，消除与配错反馈时顺手带出：连省会是明面，简称是捎带的。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.shenghui = {
    id: 'shenghui',
    name: '省份连省会',
    hint: '冀连河北，省会是石家庄',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '北京', r: '北京', note: '简称京' },
      { l: '天津', r: '天津', note: '简称津' },
      { l: '上海', r: '上海', note: '简称沪' },
      { l: '重庆', r: '重庆', note: '简称渝' },
      { l: '河北', r: '石家庄', note: '简称冀' },
      { l: '山西', r: '太原', note: '简称晋' },
      { l: '辽宁', r: '沈阳', note: '简称辽' },
      { l: '吉林', r: '长春', note: '简称吉' },
      { l: '黑龙江', r: '哈尔滨', note: '简称黑' },
      { l: '江苏', r: '南京', note: '简称苏' },
      { l: '浙江', r: '杭州', note: '简称浙' },
      { l: '安徽', r: '合肥', note: '简称皖' },
      { l: '福建', r: '福州', note: '简称闽' },
      { l: '江西', r: '南昌', note: '简称赣' },
      { l: '山东', r: '济南', note: '简称鲁' },
      { l: '河南', r: '郑州', note: '简称豫' },
      { l: '湖北', r: '武汉', note: '简称鄂' },
      { l: '湖南', r: '长沙', note: '简称湘' },
      { l: '广东', r: '广州', note: '简称粤' },
      { l: '海南', r: '海口', note: '简称琼' },
      { l: '四川', r: '成都', note: '简称川' },
      { l: '贵州', r: '贵阳', note: '简称贵' },
      { l: '云南', r: '昆明', note: '简称云' },
      { l: '陕西', r: '西安', note: '简称陕' },
      { l: '甘肃', r: '兰州', note: '简称甘' },
      { l: '青海', r: '西宁', note: '简称青' },
      { l: '台湾', r: '台北', note: '简称台' },
      { l: '内蒙古', r: '呼和浩特', note: '简称蒙' },
      { l: '广西', r: '南宁', note: '简称桂' },
      { l: '西藏', r: '拉萨', note: '简称藏' },
      { l: '宁夏', r: '银川', note: '简称宁' },
      { l: '新疆', r: '乌鲁木齐', note: '简称新' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
